import { Flow, Text } from 'bold-ui'
import { Ciap, Procedimento } from 'graphql/types.generated'
import { useMemo } from 'react'

import { convertToCiapsProcedimentos } from './converter-historicoCiapProcedimento'

interface HistoricoCiapProcedimentoProps {
  filtro: string | null | undefined
  ciaps: Ciap[]
  procedimentos?: Procedimento[] | null
  showLabel?: boolean
}

type TipoCiapProcedimento = 'CIAP' | 'SISAB'

export interface CiapProcedimento {
  codigo: string
  descricao: string
  tipo: TipoCiapProcedimento
}

export const HistoricoCiapProcedimento = (props: Readonly<HistoricoCiapProcedimentoProps>) => {
  const { filtro, ciaps, procedimentos, showLabel = false } = props

  const ciapsProcedimentos = useMemo(() => {
    return convertToCiapsProcedimentos(filtro, ciaps, procedimentos)
  }, [filtro, ciaps, procedimentos])

  return (
    <Flow direction='vertical' gap={0}>
      {ciapsProcedimentos.map((item) => (
        <Flow key={item?.codigo} direction='horizontal' gap={0.5}>
          <Text fontWeight='bold'>
            {item?.descricao} - {item?.codigo}
          </Text>
          {showLabel && item?.tipo === 'CIAP' && <Text>(CIAP-2)</Text>}
        </Flow>
      ))}
    </Flow>
  )
}
